import PropTypes from 'prop-types';
import React from 'react';
import Sticky from 'react-stickynode';
import { GoogleDFP } from '@surfline/quiver-react';
import loadAdConfig from '../../utils/adConfig';

const StickyAdUnit = ({ isDesktop, qaFlag, adUnit, bottomBoundary, dfpKeyword }) => {
  const feedAdUnit = (
    <div className="sl-sticky-ad-unit">
      <GoogleDFP adConfig={loadAdConfig(adUnit, [['qaFlag', qaFlag], ['contentKeyword', dfpKeyword]])} />
    </div>
  );
  return isDesktop ? (
    <Sticky bottomBoundary={bottomBoundary}>
      {feedAdUnit}
    </Sticky>
  ) : feedAdUnit;
};

StickyAdUnit.propTypes = {
  isDesktop: PropTypes.bool,
  qaFlag: PropTypes.string,
  adUnit: PropTypes.string,
  bottomBoundary: PropTypes.string,
  dfpKeyword: PropTypes.string,
};

StickyAdUnit.defaultProps = {
  isDesktop: false,
  qaFlag: null,
  adUnit: null,
  bottomBoundary: '.quiver-page-rail--right',
  dfpKeyword: null,
};


export default StickyAdUnit;
